import React from 'react';
import { Form, Input } from 'antd';
import { fieldNames, maxNameLength } from './constants';

const { Item: FormItem } = Form;

const NameField = ({ form, initialValue, disabled = false }) => {
  const { getFieldDecorator, getFieldValue } = form;

  return (
    <FormItem
      label="Наименование документа"
      colon={false}
      extra={`${
        (getFieldValue(fieldNames.name) ?? initialValue)?.length || 0
      }/${maxNameLength}`}
    >
      {getFieldDecorator(fieldNames.name, {
        initialValue: initialValue ?? '',
        rules: [
          {
            max: maxNameLength,
            message: 'Наименование должно быть не больше 50 символов',
          },
          {
            required: disabled ? false : true,
            whitespace: true,
            message: 'Укажите наименование документа',
          },
        ],
      })(<Input disabled={disabled} />)}
    </FormItem>
  );
};

export default NameField;
